import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { HttpError } from './http-errors';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LoadingService } from '../utils/loading/loading.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
	constructor(private router: Router, private loadingService: LoadingService) {}

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const logFormat = 'background: maroon; color: white';

		return next.handle(request).pipe(
			catchError((err, caught: Observable<HttpEvent<any>>) => {
				if (err instanceof HttpErrorResponse && err.status == 500) {
					//this.router.navigate([ '' ], { queryParams: { returnUrl: request.url } });
					this.loadingService.hide();
					return of(err as any);
				}
				throw err;
			})
		);
	}
}
